import { render } from "./ServicesDetail.vue?vue&type=template&id=773f3fd8&scoped=true"
import script from "./ServicesDetail.vue?vue&type=script&lang=js"
export * from "./ServicesDetail.vue?vue&type=script&lang=js"

import "./ServicesDetail.vue?vue&type=style&index=0&id=773f3fd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-773f3fd8"]])

export default __exports__